module.exports = __webpack_public_path__ + "img/hcdl_gallery0.c4d9d34d.jpg";